import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { hasActiveSession } from "../Component/CommonFunctionality/SessionTimeoutWatcher";

// Redirects to login page if the user is not logged in.
// Change the login check / redirect target here to update it everywhere.
const useAuthGuard = () => {
  const navigate = useNavigate();

  useEffect(() => {
    if (!hasActiveSession()) {
      navigate("/");
    }
  }, []);
};

export default useAuthGuard;
